// extracted by mini-css-extract-plugin
export default {"buttonWrap":"ProductResourceItem_buttonWrap__sJ0oh"};